
import React from "react";
import "../components/styles/loader.scss";
import { useState, useEffect } from "react";

const Spinner = ({ title }) => {
  return (
    <div id="loader-wrapper">
      <h4 id="loader-header">Loading {title ? title : ""} ...</h4>
      <Loader />
    </div>
  );
};

export const Loader = ({ borderWidth="1vmin" , borderColor = "white transparent white transparent", marginRight }) => {
  return <span style={{ borderWidth: borderWidth, borderColor: borderColor, marginRight: marginRight }} className="loader"></span>;
};

export default Spinner;